import { render, staticRenderFns } from "./section-hot.vue?vue&type=template&id=bb4c07ba&scoped=true&"
import script from "./section-hot.vue?vue&type=script&lang=js&"
export * from "./section-hot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4c07ba",
  null
  
)

export default component.exports